import { render, staticRenderFns } from "./BatchCard.vue?vue&type=template&id=662d0233&scoped=true"
import script from "./BatchCard.vue?vue&type=script&lang=js"
export * from "./BatchCard.vue?vue&type=script&lang=js"
import style0 from "./BatchCard.vue?vue&type=style&index=0&id=662d0233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d0233",
  null
  
)

export default component.exports